import React, { useState, useEffect, useRef } from "react";
import {
  FunnelIcon,
  ChevronDownIcon,
  CheckIcon,
} from "@heroicons/react/24/outline";

export default function NewsFilters({ sort, setSort }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const sorts = [
    { value: "recent", label: "Plus récent" },
    { value: "old", label: "Plus ancien" },
    { value: "popular", label: "Plus populaire" },
  ];

  /* -------------------------------
        FERMETURE SI CLICK EXTERNE
  ------------------------------- */
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="relative group/drop" ref={ref}>
      {/* ======= BUTTON STYLE NAVBAR ======= */}
      <button
        onClick={() => setOpen(!open)}
        className="
          inline-flex items-center gap-1 px-4 py-2 
          text-sm font-medium text-[#3a3a3a] 
          rounded-full
          bg-gradient-to-r from-[#ffefc3] via-[#ffe9a6] to-[#fff9e6]
          border border-black/10
          hover:bg-white/60
          transition-all
        "
      >
        <FunnelIcon className="h-4 w-4" />
        <span>Trier</span>

        <ChevronDownIcon
          className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {/* ======= DROPDOWN PANEL (style navbar) ======= */}
      {open && (
        <div
          className="
            absolute right-0 top-full mt-2 z-50 w-60 
            bg-white/95 backdrop-blur 
            rounded-xl shadow-lg border border-black/10 overflow-hidden
            animate-dropFade
          "
        >
          {sorts.map((opt, idx) => (
            <button
              key={idx}
              onClick={() => {
                setSort(opt.value);
                setOpen(false);
              }}
              className={`w-full flex items-center justify-between px-4 py-2 text-sm 
                text-[#3a3a3a] hover:bg-[#FFF3AF]/80 transition
                ${sort === opt.value ? "bg-[#FFD76A]/40" : ""}
              `}
            >
              <span>{opt.label}</span>
              {sort === opt.value && (
                <CheckIcon className="h-4 w-4 text-[#3a3a3a]" />
              )}
            </button>
          ))}
        </div>
      )}

      {/* ANIMATIONS */}
      <style jsx>{`
        @keyframes dropFade {
          from {
            opacity: 0;
            transform: translateY(-8px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        .animate-dropFade {
          animation: dropFade 0.15s ease-out forwards;
        }
      `}</style>
    </div>
  );
}
